import { render, staticRenderFns } from "./payments-table-v2.vue?vue&type=template&id=ea0828c0&scoped=true&"
import script from "./payments-table-v2.vue?vue&type=script&lang=js&"
export * from "./payments-table-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0828c0",
  null
  
)

export default component.exports